module.exports = __webpack_public_path__ + "img/esp.46fee9f4.svg";